<template>
    <div class="modal_page center">
      <form class="modal_window d-flex d-col space-between" @submit.prevent="post">
        <div class="d-flex space-between align-center">
          <div class="font-18">
            {{ $t("modal.saveEvent.title") }}
          </div>
          <s-icon color="grey" @click="closeModal">
            close
          </s-icon>
        </div>
        <div class="">
          <s-radio v-model="radio" class="py-30" :items="options" />

          <div class="pb-20 opacity-60 font-14" v-if="radio === 0">
            Only this instance of the recurring meeting will be updated.
          </div>
          <div class="pb-20 opacity-60 font-14" v-if="radio === 1">
            Individual meetings that have already been updated will be excluded from the list.
          </div>
        </div>
        <div class=" d-flex justify-end mt-40">
          <s-btn type="button" class="mr-10 black--text" @click="closeModal">
            {{ $t("modal.close") }}
          </s-btn>
          <s-btn type="submit" class="primary white--text">
            {{ $t("modal.save") }}
          </s-btn>
        </div>
      </form>
    </div>
</template>

<script setup>
import { gsap } from "gsap";
import { useStore } from 'vuex';
import { ref, onMounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const options = computed(() => [t("modal.saveEvent.this_meeting"), t("modal.saveEvent.following_meetings")]);

const radio = ref(0);

const post = async () => {
  if (radio.value === 0) await store.dispatch("schedule/updateEvent");
  if (radio.value === 1) await store.dispatch("schedule/updateEvent", { allEvents: true });
  setTimeout(() => {
    store.commit("schedule/resetState");
  }, 500);
  closeModal();
};

const closeModal = () => {
  gsap.to(".modal_page", {
    opacity: 0,
    duration: 0.3,
    ease: "power2.out",
  });
  gsap.to(".modal_window", {
    scale: 0.7,
    duration: 0.3,
    ease: "power2.out",
    onComplete: () => store.commit("modals/saveEventConfirmation", false),
  });
};

onMounted(() => {
  gsap.from(".modal_page", {
    opacity: 0,
    duration: 0.3,
    ease: "power2.out",
  });

  gsap.from(".modal_window", {
    scale: 0.7,
    duration: 0.3,
    ease: "power2.out",
  });
});
</script>

<style scoped>
.modal_page {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background: rgba(41, 41, 41, 0.6);
  z-index: 8;
}

.modal_window {
  width: 450px;
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.35);
  background-color: var(--shade1);
  color: var(--black);
  border-radius: 15px;
  overflow: auto;
  max-height: -webkit-fill-available;
  max-height: calc(100vh - 200px);
}

@media only screen and (max-width: 576px) {
  .modal_window {
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
}
</style>